import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import { formattedBalance } from "../../features/balance-and-pin/utils";
import Spinner from "../../components/Spinner";
import {
  MainContainer,
  Navbar,
  Footer,
  Page,
  Heading,
  SubHeading,
  Paragraph,
  ScheduleItem,
  Time,
  ScheduleContainer,
  Separator,
  FooterImage
} from "./styles";
import logo from "./images/playstation-logo.svg";
import digiseqLogo from "./images/digiseq-logo.png";
import footerBg from "./images/footer-bg.webp";
import copyToClipboard from "../../assets/copy-icon-white.svg";

import packageJson from "../../../package.json";

const PlayStation25 = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");
  const [showPin, setShowPin] = useState(false);
  const [copied, setCopied] = useState(false);

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );

  useEffect(() => {
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }, [copied]);

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: "?provider=much_better"
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch]);

  if (isLoading) return <Spinner />;
  return (
    <MainContainer>
      <Navbar>
        <img src={logo} alt="logo" />
        <div
          className="balance-container"
          onClick={() => setShowPin((state) => !state)}
        >
          <div className="balance-text">{showPin ? "PIN" : "BALANCE"}</div>
          {!showPin ? (
            <div className="balance-value">
              {formattedBalance(
                balanceAndPin?.balanceDetails?.availableBalance,
                balanceAndPin?.balanceDetails?.currency
              )}
            </div>
          ) : (
            <div className="balance-value">
              {balanceAndPin?.pinDetails?.pin || "N/A"}
            </div>
          )}
        </div>
      </Navbar>

      <Page>
        <Separator fullWidth />
        <Heading>WELCOME TO MUNICH!</Heading>
        <Paragraph>
          Your Playstation Tournaments keyring is not just memorabilia from the
          event, it is also a Mastercard contactless card with a daily allowance
          of €100 for your enjoyment.
        </Paragraph>
        <Paragraph>
          To use it simply tap it on any payment terminal just like you would do
          with your everyday card.
        </Paragraph>
        <Paragraph>
          When you return home you have the option to link your own personal
          payment card to your PlayStation Tournaments Keyring and carry on
          using it for contactless payments. You can do this{" "}
          <Link
            className="link"
            target="_blank"
            to={`/curve-account/?serialNumber=${serialNumber}&provider=much_better`}
          >
            here
          </Link>
          .
        </Paragraph>
        <Separator fullWidth />
        <SubHeading>UEFA CHAMPIONS LEAGUE FINAL</SubHeading>

        <ScheduleContainer>
          <Separator />
          <Paragraph align="left">Friday 30th</Paragraph>
          <ScheduleItem>
            <Time>07:30am to 11:00pm</Time>Arrival and check-in at the Ruby
            Lilly Hotel
          </ScheduleItem>
          <ScheduleItem>
            <Time>11:00am to 11:00pm</Time>UEFA Champions Festival in Munich
          </ScheduleItem>
          <ScheduleItem>
            Optional: Visit the UEFA Champions Festival at Olympiapark, open
            daily from 11:00am to 11:00pm
          </ScheduleItem>
          <Separator />
          <Paragraph align="left">Saturday 31st</Paragraph>
          <ScheduleItem>
            <Time>07:30am to 09:30am</Time>Breakfast
          </ScheduleItem>
          <ScheduleItem>
            <Time>09:30am to 04:30pm</Time>Free time
          </ScheduleItem>
          <ScheduleItem>
            <Time>04:30pm</Time>Meet in the Hotel Lobby
          </ScheduleItem>
          <ScheduleItem>
            <Time>04:45pm</Time>Shuttle transfer to the Munich Football Arena
          </ScheduleItem>
          <ScheduleItem>
            <Time>09:00pm to 11:45pm</Time>UEFA Champions League Final &
            Celebrations
          </ScheduleItem>
          <ScheduleItem>
            <Time>11:45pm to 12:15am</Time>Shuttle transfer to Hotel
          </ScheduleItem>
          <Separator />
          <Paragraph align="left">Sunday 1st</Paragraph>
          <ScheduleItem>
            <Time>07:30am to 08:00pm</Time>Shuttle transfer to the Airport
          </ScheduleItem>
        </ScheduleContainer>
      </Page>
      <FooterImage src={footerBg} alt="footer-image" />
      <Footer>
        <div className="powered-by">Powered by</div>
        <img src={digiseqLogo} alt="digiseq-logo" />
        <a
          href="https://digiseq.co.uk"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        <a
          href="https://digiseq.co.uk/terms-conditions/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms & Conditions
        </a>
        <div className="copyToClipboard">
          <img
            onClick={() => {
              navigator.clipboard.writeText(serialNumber);
              setCopied(true);
            }}
            src={copyToClipboard}
            alt="copy to clipboard"
          />
          <p>ID: {serialNumber}</p>
        </div>
        <div className="version">
          <p>v.{packageJson.version}</p>
        </div>
        {copied && (
          <p>
            <b>Copied to clipboard</b>
          </p>
        )}
      </Footer>
    </MainContainer>
  );
};

export default PlayStation25;
